// PlaceOrderDrawer.jsx
import { useState, useEffect } from 'react';
import {
    Drawer,
    Box,
    IconButton,
    Typography,
    Button,
    Paper,
    Chip,
    Radio
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { pageStyles } from "../../Styles/pageStyles";
import { useTheme } from "@emotion/react";
import { commonServices } from "../../Services/commonServices";
import { apiHandler, LoaderFun, ErrLoaderOff, widthData } from "@shared/Functions/apiHandler";
import CartProducts from "./cartProducts";
import DeleteModel from "@shared/Components/deleteModel";
import NoProducts from "../delivery/NoProducts";
import AddressDrawer from "../account/addressDrawer";
import ConfirmOrderDrawer from "./confirmOrder";
import { useDrawerOpenFun } from "../../Context/modelContext";
import MiniLoader from "@shared/Components/miniLoader";


export default function Cart({
    open,
    onClose,
}) {

    const theme = useTheme();
    const classes = pageStyles(theme);
    const token = sessionStorage.getItem("token");
    const [productList, setProductList] = useState([]);
    const [deleteModel, setDeleteModel] = useState(false);
    const [deleteTitle, setDeleteTitle] = useState("");
    const [deletepayload, setDeletePaload] = useState("");
    const [selectedAddress, setSelectedAddress] = useState(null);
    const { addressDrawer, setAddressDrawer } = useDrawerOpenFun();
    const [confirmOrderDrawer, setConfirmOrderDrawer] = useState(false);
    const [addressActive, setAddressActive] = useState(0);
    const [payload, setPayload] = useState({})
    const [calculatedPrice, setCalculatedPrice] = useState([]);
    const [productValues, setProductValues] = useState(
        productList?.map(() => ({ amount: "", liters: "" }))
    );
    const [loader, setLoader] = useState(false);

    const handlePriceChange = (index, e) => {
        const value = e.target.value.replace(/\D/g, ""); // Digits only
        const naira = Number(value);
        const selectedPrice = productList[index]?.product?.price || 1;
        const liters = +(naira / selectedPrice).toFixed(1);

        setProductValues((prev) =>
            prev.map((item, i) =>
                i === index ? { amount: value, liters, productId: item.productId } : item
            )
        );
    };

    const handleLitersChange = (index, type) => {
        setProductValues((prev) =>
            prev.map((item, i) => {
                if (i !== index) return item;
                const selectedPrice = productList[index]?.product?.price || 1;
                const stock = productList[index]?.product?.stock;

                // calculate new liters based on action type
                const newLiters =
                    type === 1
                        ? Math.min(item.liters + 1, stock)
                        : Math.max((item.liters || 0) - 1, 0);

                // calculate new amount
                const newAmount = Math.round(newLiters * selectedPrice);

                return {
                    ...item,
                    liters: +newLiters.toFixed(1),
                    amount: newAmount.toString(),
                    productId: item.productId,
                };
            })
        );
    };

    const getCartDetails = async () => {
        setLoader(true);
        const res = await commonServices.myCart();

        apiHandler(res);
        LoaderFun(res, setLoader);
        ErrLoaderOff(res, setLoader);

        if (res.status === 200) {
            setProductList(res?.data?.data?.cartDetails);
            setProductValues(res?.data?.data?.cartDetails?.map((data) => (
                {
                    amount: 0,
                    liters: 0,
                    purchaseType: data?.product?.purchaseType,
                    productId: data?.product?.productId,
                })));
        }

    }

    const getAllUserAddress = async () => {
        if (!token) return;
        const res = await commonServices.userAllAddress();
        apiHandler(res);
        if (res?.status === 200) {
            setSelectedAddress(res?.data?.data?.userAddress);
        }
    }

    const deleteCart = async (payload) => {
        setDeletePaload(payload);
        setDeleteModel(true);
        setDeleteTitle(`Are you sure you want to delete this ${payload.name} product from cart?`);
        delete payload.name;
    }

    const deleteAPI = async () => {
        const res = await commonServices.addToCart(deletepayload);
        apiHandler(res, classes.successToast, true);
        if (res?.status === 200) {
            getCartDetails();
            setDeleteModel(false);
        }
    }

    const validateProductQuantities = (productValues, productList) => {

        const isInvalid = productValues.some((value) => {
            const matchedProduct = productList.find(
                (item) => item.product.productId === value.productId
            );
            console.log(matchedProduct);

            if (matchedProduct?.length === 0) return false; // No match, skip

            const { minOrder, stock } = matchedProduct.product;


            if (value.liters < minOrder) {
                alert(
                    `Minimum order quantity for ${matchedProduct.product.name} is ${minOrder} ${matchedProduct.product.measurement.name}.`
                );
                return true; // stop further checks
            }

            if (value.liters > stock) {
                alert(
                    `Available Stock for ${matchedProduct.product.name} is ${stock} ${matchedProduct.product.measurement.name}.`
                );
                return true; // stop further checks
            }

            return false;
        });

        return !isInvalid;
    };

    const checkout = async () => {
        if (!validateProductQuantities(productValues, productList)) {
            return;
        }

        let payload = {
            addressId: selectedAddress[addressActive]?.id,
            purchaseProducts: productList?.map((data, index) => {
                return {
                    productId: data?.product?.productId,
                    qty:
                        data?.product?.purchaseType == 1
                            ? Number(productValues[index]?.amount)
                            : Number(productValues[index]?.liters),
                };
            }),
            deliveryType: 1,
            redeemPoints: false,
        };

        setPayload(payload);
        setConfirmOrderDrawer(true);
    }

    useEffect(() => {
        token &&getCartDetails();
    }, [open, confirmOrderDrawer]);

    useEffect(() => {
        token && getAllUserAddress();
    }, [addressDrawer]);

    return (
        <>
            <Drawer
                anchor="right"
                open={open}
                onClose={onClose}
                slotProps={{
                    paper: {
                        sx: widthData,
                    },
                }}
            >

                <AddressDrawer
                    open={addressDrawer}
                    setOpen={setAddressDrawer}
                    selectedAddress={[]}
                />

                <ConfirmOrderDrawer
                    open={confirmOrderDrawer}
                    payload={payload}
                    productList={productList}
                    onClose={() => { setConfirmOrderDrawer(false) }}
                    calculatedPrice={calculatedPrice}
                    setCalculatedPrice={setCalculatedPrice}
                />

                <DeleteModel
                    openDialog={deleteModel}
                    setOpenDialog={setDeleteModel}
                    title={deleteTitle}
                    functionalCall={deleteAPI}
                />

                {loader ? <MiniLoader /> :
                    <Box sx={classes.cartMyDiv}>
                        <Box sx={classes.flex_c}>
                            <IconButton size="small" onClick={onClose}>
                                <CloseIcon />
                            </IconButton>

                            <Typography >
                                Cart
                            </Typography>
                        </Box>

                        {productList?.length === 0 && (
                            <NoProducts title="No Products Available at the Cart, Please Add Products" />
                        )}

                        {/* Purchase Type - 1 (Price) */}
                        {productList && productList?.map((fuel, index) => (
                            <CartProducts
                                key={index}
                                fuel={fuel}
                                index={index}
                                amount={productValues[index]?.amount}
                                liters={productValues[index]?.liters}
                                priceChange={(e) => handlePriceChange(index, e)}
                                handleLitersChange={handleLitersChange}
                                productValues={productValues}
                                deleteCart={deleteCart}

                            />
                        ))}

                        {/* Delivery Address */}
                        {productList?.length != 0 && <Paper variant="outlined" sx={classes.paperDiv}>
                            <Box sx={classes.flex_center_btn}>
                                <Typography sx={classes.darkTextsmd500}>Delivery Address</Typography>
                                <Chip
                                    variant="contained"
                                    size="small"
                                    label="Add New Address"
                                    sx={classes.addAddressBtn}
                                    onClick={() => setAddressDrawer(true)}
                                />
                            </Box>


                            <Box sx={{ ...classes.savedCard, mt: 2 }}>
                                {selectedAddress?.length === 0 &&
                                    <Box sx={{ ...classes.flex_c_c, my: 2 }}>
                                        <Typography sx={classes.darkTextsmd500}>No Saved Address</Typography>
                                    </Box>
                                }

                                {selectedAddress?.map((a, index) => (
                                    <Box key={a.id} onClick={() => setAddressActive(index)} sx={{ cursor: "pointer" }}>
                                        <Box sx={{ ...classes.flex_c, mt: 1 }}>
                                            <Radio
                                                size="small"
                                                checked={addressActive === index}
                                                name="radio-buttons"
                                            />
                                            <Box>
                                                <Typography sx={classes.darkTextSmall}>
                                                    {a?.name}
                                                </Typography>
                                                <Typography sx={classes.darkTextsmd500}>
                                                    {a?.lineOne},
                                                    {a?.lineTwo && <span> {a?.lineTwo}, </span>}
                                                    {a?.landmark && <span> {a?.landmark}, </span>}
                                                    {a?.city && <span> {a?.city}, </span>}
                                                    {a?.postalCode}.
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Box>
                                ))}
                            </Box>
                        </Paper>}



                        {/* Confirm */}
                        {productList?.length != 0 && selectedAddress?.length != 0 && <Button
                            variant="contained"
                            sx={{ my: 2 }}
                            onClick={checkout}
                        >
                            Checkout
                        </Button>}
                    </Box>}
            </Drawer>


        </>
    );
}
